<template>
<div>

    <div v-if="items" class="animate__animated animate__fadeIn mt-3 historyPoint">

        <div class="row ">
            <div class="col-12" v-for="item in items" :key="item.history_id">

                <v-card class="mx-auto " elevation="1">

                    <v-card-text class="pa-2">

                         <div class="row">
                            <div class="col-sm-2  text-center point">
                               {{item.point}}
                            </div>
                            <div class="col-sm-10">
                                <div class="ruleTitle">{{item.rule_title}}</div>
                                <div class="itemTitle mt-2" v-if="item.content_title">{{item.content_title}}</div>
                                <div class="mt-2">{{item.created}}</div>
                                
                            </div>
                        </div>
                        

                    </v-card-text>
                </v-card>

            </div>
        </div>

    </div>

    <div class="pg">
        <Paginator v-if="totalItemsCount>0" :rows="12" :totalRecords="totalItemsCount" @page="onPage($event)"></Paginator>
    </div>
</div>
</template>

<script>
export default {

    components: {

    },

    data: () => ({

        totalItemsCount: 0,

        page: 0,
        items: null,

    }),

    computed: {

    },

    watch: {

    },
    methods: {

        getItems() {

            let url = "account/historyPoint";

            this.$FULL_LOADING = true
            let $vm = this;

            this.$API
                .post(url, $vm.formData())
                .then(function (res) {
                    $vm.checkApi(res)
                    $vm.totalItemsCount = res.data.total
                    $vm.items = res.data.items

                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        onPage(event) {
            this.page = event.page + 1
            this.getItems()
            this.setPageNo(this.page)

        },

    },
    created() {

        if (this.pageNo) {
            this.page = this.pageNo
        }

        this.getItems();

    },
};
</script>
